export default __webpack_public_path__ + "static/media/Rovers_page.4c0d1078.gif";